<template>
	<div :class="this.sizeClasses">
		<slot />
	</div>
</template>
<script>
export default {
	props: {
		sizes: {
			type: Object,
			required: true,
			default: {}
		},
	},
	data: function () {
		return {
			colspans: {
				"small": 12,
				"medium": 4,
				"large": 3
			},
		}
	},
	computed: {
		sizeClasses() {
			return `col-xs-${this.sizes.small} col-md-${this.sizes.medium} col-lg-${this.sizes.large}`
		}
	},
	mounted() {
		this.colspans = {...this.colspans, ...this.sizes}
	},
}
</script>